import React from 'react'
import { useRandomId } from '@fs/zion-frontend-friends'

export default function FaceFeature({ scaleX, gradient, skinOutline, fill, outline }) {
  const randomGradientId1 = `_${useRandomId()}`

  return (
    <g transform={`scale(${scaleX},1)`}>
      <path
        d="M107.98 41.87C107.98 41.87 80.3505 27.42 78.9505 25.66C77.5505 23.9 76.6105 1 76.6105 1H54.6005C54.6005 1 53.6605 23.9 52.2605 25.66C50.8605 27.42 23.2305 41.87 23.2305 41.87C23.2305 41.87 35.4805 56.92 65.6105 56.92C95.7405 56.92 107.98 41.87 107.98 41.87Z"
        fill={`url(#${randomGradientId1})`}
        stroke={skinOutline}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M121.7 47.57C118.62 43.94 84.06 26.76 84.06 26.76C84.06 26.76 79.86 38.15 65.61 38.15C51.36 38.15 47.16 26.76 47.16 26.76C47.16 26.76 12.6 43.93 9.52 47.57C6.44 51.2 2 73.55 2 73.55H129.23C129.22 73.55 124.78 51.2 121.7 47.57Z"
        fill={fill}
        stroke={outline}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M39.6797 30.55C39.6797 30.55 46.7797 44.75 65.6097 44.75C84.4397 44.75 91.5397 30.55 91.5397 30.55"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
        fill="none"
      />
      <defs>
        <linearGradient
          id={randomGradientId1}
          x1="65.6054"
          y1="33.1932"
          x2="65.6054"
          y2="22.8897"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.1476" stopColor={gradient[1]} />
          <stop offset="0.8447" stopColor={gradient[0]} />
        </linearGradient>
      </defs>
    </g>
  )
}
